import { createStyles, makeStyles } from '@material-ui/core/styles'

export const useStyles = makeStyles(() =>
  createStyles({
    wrapperComponents: {
      display: 'flex',
      flexDirection: 'column',
      gap: '16px',
    },
    wrapperFieldsListContainer: {
      display: 'flex',
      flex: 1,
      border: '1px solid #E0E0E0',
      boxShadow: 'none',
      flexDirection: 'column',
      padding: '8px 0px',
      '& .MuiTypography-gutterBottom': {
        marginBottom: '0px',
      },
    },
    titleContainer: {
      padding: '8px 16px',
    },
    defaultText: {
      textAlign: 'center',
      fontWeight: 400,
    },
    formContainer: {
      display: 'flex',
      flexDirection: 'column',
      width: '100%',
      flex: 1,
      minHeight: 0,
    },
    formGroup: {
      marginTop: '12px',
      padding: '0px 8px',
      paddingRight: 0,
      width: '100%',
      display: 'flex',
      flex: 1,
      minHeight: 0,
      flexDirection: 'column',
      gap: '4px',
      overflow: 'hidden',
    },
    loadingContainer: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      flex: 1,
    },
  }),
)
